<template>
  <slot v-if="show"></slot>
  <slot v-else name="else"></slot>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue';

const show = ref(false);
const scrolling = inject('scrolling') || ref(false);

onMounted(() => {
  show.value = !scrolling.value;
});

watch(scrolling, () => {
  if (!scrolling.value) show.value = true;
});
</script>
